import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";

export const preferencesListLoader: LoaderFunction = async (args) => {

    const result = await axiosApi.get("/api/preferences/", { params: args.params });

    return result.data
}